import React from "react";
import * as R from "ramda";
import { Switch, Card, Popover, Icon, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { FormItem } from "@worcket/common/components/controls";
import { useTranslation } from "react-i18next";

import Button from "../../../../../components/Button";
import { getCountry } from "../../../../../utils/data/static/countries";

import styled from "styled-components/macro";

const Msg = styled.div`
  width: 220px;
  display: flex;
`;

const FormItemWrapper = styled.div`
  &:not(:last-of-type) {
    margin-right: 10px;
  }
  &:hover {
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  }
  transition: 0.3s ease;

  .ant-card-cover {
    height: 110px;
    display: flex;
    justify-content: center;
    position: relative;
  }
  img {
    width: 75%;
  }
  .ant-card-body {
    display: none;
  }

  .ant-card-actions {
    height: 70px;
    display: flex;
    align-items: center;

    /* Reset ant-card-actions of loading button */
    & > li > span i {
      width: auto !important;
      color: currentColor !important;
    }
  }

  .ant-form-item {
    margin: 0;
  }
`;

const ProviderCountry = styled.div`
  display: flex !important;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  position: absolute;
  bottom: -12px;
  background-color: #fafafa;
  border-radius: 50%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 24px !important;
  height: 24px;
  overflow: hidden;
  img {
    width: 40px;
    height: initial;
  }
`;

const TooltipContainer = styled.article`
  text-align: center;
`;

const JobItem = ({
  logo,
  country,
  flag,
  feedConnected,
  form,
  name,
  onConnect
}) => {
  const { t } = useTranslation(["opportunity"]);
  const connecting = useSelector(
    R.pathEq(["company", "socialAccounts", "loading"], name)
  );

  return (
    <FormItemWrapper>
      <Card
        style={{ maxWidth: 169 }}
        cover={
          <>
            <img
              alt={name}
              src={logo}
              style={{ marginTop: name === "linkedin" ? 9 : 0 }}
            />
            {flag && (
              <Tooltip
                placement="top"
                title={
                  <TooltipContainer>
                    <div className="name-wrapper">{getCountry(country)}</div>
                  </TooltipContainer>
                }
              >
                <ProviderCountry>
                  <img src={flag} alt={country} />
                </ProviderCountry>
              </Tooltip>
            )}
          </>
        }
        actions={[
          feedConnected ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              {t("opportunity:wizard.multiposting.publish")}
              {name === "bumeran" ? (
                <Popover
                  placement="topLeft"
                  disabled={false}
                  content={
                    <Msg>
                      <Icon
                        type="info-circle"
                        theme="filled"
                        style={{ marginTop: 5 }}
                      />
                      <div style={{ marginLeft: 10 }}>
                        {t(
                          "opportunity:wizard.multiposting.integrations.bumeran.credits"
                        )}
                      </div>
                    </Msg>
                  }
                >
                  <FormItem
                    form={form}
                    name={name}
                    decoratorProps={{ valuePropName: "checked" }}
                    render={
                      <Switch
                        style={{ marginLeft: 10 }}
                        data-test={`${name}-switch-published`}
                      />
                    }
                  />
                </Popover>
              ) : (
                <FormItem
                  form={form}
                  name={name}
                  decoratorProps={{ valuePropName: "checked" }}
                  render={
                    <Switch
                      style={{ marginLeft: 10 }}
                      data-test={`${name}-switch-published`}
                    />
                  }
                />
              )}
            </div>
          ) : (
            <Button size="sm" loading={connecting} onClick={onConnect}>
              {connecting
                ? t("opportunity:wizard.multiposting.connecting")
                : t("opportunity:wizard.multiposting.connect")}
            </Button>
          )
        ]}
      />
    </FormItemWrapper>
  );
};

export default JobItem;
